import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import shoppingCart from "@/assets/SVG/shoppingCart.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(shoppingCart), { class: "icon" }))
}
}

})